let store = require("../store");
let actions = require("../actions");

let FormControls = mc.widgets.FormControls;
let FormFeedback = mc.widgets.FormFeedback;
let FormRange = mc.widgets.FormRange;
let Orderable = mc.widgets.Orderable;
let IconButton = mc.widgets.IconButton;

let ProgramUtil = {
  formatDay: function (dayIndex, scheduleMode) {
    if (scheduleMode === "ORDINAL") {
      return tx("day_n", { n: dayIndex + 1 });
    }

    return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][dayIndex];
  },

  formatTime: function (hourIndex) {
    if (hourIndex > -1) {
      return (hourIndex % 12 === 0 ? "12" : (hourIndex % 12)) + (hourIndex < 12 ? ":00 AM" : ":00 PM");
    }

    return tx("period.ORDINAL." + hourIndex);
  }
};

let ProgramView = function (props) {
  let { program, disabled } = props;

  if (!program) {
    return null;
  }

  let editProgram = function () {
    mc.ui.modal(<ProgramForm {...props}/>, { width: "600px", height: "450px", dismissable: disabled });
  };

  return (
    <div className="rc-program-view">
      <div style={{ textAlign: "right" }}>
        <IconButton
          icon="configure"
          scale={1.1}
          label={tx("options")}
          disabled={disabled}
          onPress={editProgram}/>
      </div>

      {program.schedules.map(function (schedule, i) {
        return (
          <div key={i} data-schedule-name={schedule.displayName} data-schedule-index={i} data-schedule-length={schedule.durationDays}>
            <h2>
              {schedule.displayName + " — " + tx("count_days", { _count: schedule.durationDays })}
            </h2>
            <ScheduleTemplate {...props} scheduleIndex={i}/>
          </div>
        );
      })}
    </div>
  );
};

let ScheduleTemplate = function (props) {
  let { program, activities, diaries, studyId, scheduleIndex, disabled } = props;
  let schedule = program.schedules[scheduleIndex];
  let scheduleMode = schedule.mode;
  let scheduleType = program.scheduleType;
  let days = [0, 1, 2, 3, 4, 5, 6].slice(0, schedule.columns.length);
  let width = Math.floor(85 / days.length) + "%";
  let activityMap = mc.utils.hash(activities, "id");
  let diaryMap = mc.utils.hash(diaries, "id");

  return (
    <table className="rc-program-schedule mc-table" data-locked={disabled}>
      <colgroup>
        <col width="15%"/>
        {days.map((i) => <col key={i} width={width}/>)}
      </colgroup>
      {days.length > 1 && (
        <thead>
          <tr>
            <th></th>
            {days.map(function (i) {
              return (
                <th key={i}>
                  {ProgramUtil.formatDay(i, scheduleMode)}
                </th>
              );
            })}
          </tr>
        </thead>
      )}
      <tbody>
        {(scheduleType === "ADVANCED" ? d3.range(-1, 24) : [-1, -2, -3, -4]).map(function (h, i) {
          let editSchedule = function (dayIndex, hourIndex) {
            let form = (
              <ScheduleForm
                program={program}
                studyId={studyId}
                scheduleIndex={scheduleIndex}
                dayIndex={dayIndex}
                hourIndex={hourIndex}
                activities={activities}
                diaries={diaries}/>
            );

            mc.ui.modal(form, { height: "500px", dismissable: false });
          };

          return (
            <tr key={h}>
              <th>{ProgramUtil.formatTime(h)}</th>

              {days.map(function (j) {
                let rows = schedule.columns[j].rows;
                let row = rows && rows.find((row) => row.hour === h);
                let list = null;

                if (row) {
                  list = row.tasks.map(function (taskEntry, k) {
                    let taskId = taskEntry.id;
                    let task = activityMap[taskId] || diaryMap[taskId];

                    return (
                      <div key={[k, taskId]} data-task-id={taskId}>
                        {task.displayName}
                      </div>
                    );
                  });
                }

                return (
                  <td key={j} onClick={!disabled ? editSchedule.bind(this, j, h) : undefined}>
                    {list}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

class ProgramForm extends React.Component {
  constructor(props) {
    super(props);

    let program = mc.utils.clone(props.program);

    this.state = {
      program: program,
      studyId: props.studyId,
      errors: [],
      submitting: false
    };
  }

  saveProgram() {
    let program = mc.utils.clone(this.state.program);
    let { studyId } = this.props;
    let accept = program.scheduleType === "ADVANCED" ? d3.range(-1, 24) : [-1, -2, -3, -4];
    let method = program.id ? "UPDATE" : "CREATE";

    program.schedules.forEach(function (schedule) {
      schedule.columns.forEach(function (column, i) {
        schedule.columns[i].rows = [].concat(column.rows.filter((row) => accept.includes(row.hour)));
      });
    });

    actions.saveProgram(program, studyId, method).then((function (payload) {
      if (payload.errors.length) {
        this.setState({
          errors: payload.errors,
          submitting: false
        });
      }
      else {
        mc.ui.modal(null);
      }
    }).bind(this));

    this.setState({
      submitting: true
    });
  }

  cancel() {
    mc.ui.modal(null);
  }

  orderSchedules(order) {
    let program = mc.utils.clone(this.state.program);

    program.schedules = order.map(function (i) {
      return program.schedules[i];
    });

    this.setState({ program });
  }

  setScheduleDisplayName(index, evt) {
    let program = mc.utils.clone(this.state.program);

    program.schedules[index].displayName = evt.target.value;

    this.setState({ program });
  }

  setScheduleDurationDays(index, evt) {
    let program = mc.utils.clone(this.state.program);

    program.schedules[index].durationDays = parseInt(evt.target.value) || null;

    this.setState({ program });
  }

  setScheduleCycleLength(index, cycleLength) {
    let program = mc.utils.clone(this.state.program);
    let schedule = program.schedules[index];
    let filler = new Array(6).fill({ wearSensors: true, rows: [] });
    let n = cycleLength;

    if (n === 0) {
      n = 7;
      schedule.mode = "WEEKLY";
    }
    else {
      schedule.mode = "ORDINAL";
    }

    schedule.columns = schedule.columns.concat(filler).splice(0, n);

    this.setState({ program });
  }

  setScheduleType(evt) {
    let program = mc.utils.clone(this.state.program);
    program.scheduleType = evt.target.value;

    this.setState({ program });
  }

  addSchedule() {
    let program = mc.utils.clone(this.state.program);

    program.schedules.push({
      displayName: "New Phase",
      durationDays: 30,
      mode: "ORDINAL",
      columns: [{ wearSensors: true, rows: [] }]
    });

    this.setState({ program });
  }

  deleteSchedule(index, evt) {
    let program = mc.utils.clone(this.state.program);

    program.schedules.splice(index, 1);

    this.setState({ program });
  }

  isValid() {
    let pc = this.state.program;

    return pc.schedules.every(function (schedule) {
      return schedule.displayName.trim().length > 0 &&
             schedule.durationDays > 0 &&
             schedule.durationDays >= schedule.columns.length;
    });
  }

  render() {
    let program = this.state.program;

    if (!program) {
      return null;
    }

    let schedules = program.schedules;
    let scheduleType = program.scheduleType;
    let scheduleDesc = function (days) {
      return days === 0 ? tx("scheduleMode.WEEKLY") : tx("cycle_length", { days });
    };

    return (
      <div className="rc-program-form-view">
        <h1>{tx("program")}</h1>
        <section>
          <h2>{tx("program_mode")}</h2>
          <select value={scheduleType} onChange={this.setScheduleType.bind(this)}>
            <option value="SIMPLE">
              {tx("programMode.SIMPLE")}
            </option>
            <option value="ADVANCED">
              {tx("programMode.ADVANCED")}
            </option>
          </select>
        </section>
        <section>
          <h2>{tx("program_phases")}</h2>
          <div className="rc-program-form-view-orderable">
            <Orderable onOrder={this.orderSchedules.bind(this)}>
              {schedules.map((function (schedule, i) {
                return (
                  <div key={i} orderId={i}>
                    <input
                      type="text"
                      size="20"
                      value={schedule.displayName}
                      onChange={this.setScheduleDisplayName.bind(this, i)}/>
                    <input
                      type="number"
                      size="3"
                      min="1"
                      value={schedule.durationDays}
                      onChange={this.setScheduleDurationDays.bind(this, i)}/>
                    <FormRange
                      min={0}
                      max={7}
                      value={schedule.mode === "WEEKLY" ? 0 : schedule.columns.length}
                      tx={scheduleDesc}
                      onChange={this.setScheduleCycleLength.bind(this, i)}/>
                    <IconButton
                      icon="minus"
                      label={tx("delete_phase")}
                      disabled={schedules.length === 1}
                      onPress={this.deleteSchedule.bind(this, i)}/>
                    {i === schedules.length - 1 && (
                      <IconButton icon="plus" label={tx("add_phase")} onPress={this.addSchedule.bind(this)}/>
                    )}
                  </div>
                );
              }).bind(this))}
            </Orderable>
          </div>
        </section>
        <FormFeedback errors={this.state.errors}/>
        <FormControls
          onSave={this.saveProgram.bind(this)}
          onCancel={this.cancel.bind(this)}
          enabled={this.isValid() && !this.state.submitting}/>
      </div>
    );
  }
}

let UnassignedOption = function (props) {
  let { id, displayName, type, onAssign } = props;

  return (
    <div className="rc-schedule-form-item" data-id={id} data-type={type} data-assigned="false">
      <div>{displayName}</div>
      <IconButton icon="plus" onPress={onAssign}/>
    </div>
  );
};

let AssignedOption = function (props) {
  let { id, displayName, type, onUnassign } = props;

  return (
    <div className="rc-schedule-form-item" data-id={id} data-type={type} data-assigned="true">
      <div>{displayName}</div>
      <IconButton icon="minus" onPress={onUnassign}/>
    </div>
  );
};

class ScheduleForm extends React.Component {
  constructor(props) {
    super(props);

    let {
      program,
      activities,
      diaries,
      scheduleIndex,
      dayIndex,
      hourIndex
    } = props;

    let assigned = (program.schedules[scheduleIndex].columns[dayIndex].rows.find(function (row) {
      return row.hour === hourIndex;
    }) || {}).tasks || [];

    let unassigned = activities.concat(diaries).filter(function (task) {
      return task.mode !== "SUPERVISED";
    });

    this.state = {
      assigned,
      unassigned,
      term: ""
    };
  }

  assign(taskId) {
    let assigned = [].concat(this.state.assigned);
    assigned.push({ id: taskId, sets: 1, repetitions: 1 });

    this.setState({ assigned });
  }

  unassign(index) {
    let assigned = [].concat(this.state.assigned);
    assigned.splice(index, 1);

    this.setState({ assigned });
  }

  reorder(orderIds) {
    let assigned = orderIds.map((idx) => this.state.assigned[idx]);

    this.setState({ assigned });
  }

  title() {
    let { program, scheduleIndex, dayIndex, hourIndex } = this.props;
    let schedules = program.schedules;
    let name = schedules[scheduleIndex].displayName;
    let day = ProgramUtil.formatDay(dayIndex, schedules[scheduleIndex].mode);
    let time = ProgramUtil.formatTime(hourIndex);

    return name + ": " + day + ": " + time;
  }

  setTerm(evt) {
    this.setState({
      term: evt.target.value
    });
  }

  saveSchedule() {
    let { scheduleIndex, dayIndex, hourIndex, studyId } = this.props;
    let program = mc.utils.clone(this.props.program);
    let assigned = this.state.assigned;
    let rows = program.schedules[scheduleIndex].columns[dayIndex].rows;
    let idx = rows.findIndex((row) => row.hour === hourIndex);
    let method = program.id ? "UPDATE" : "CREATE";

    if (idx > -1) {
      rows.splice(idx, 1);
    }

    rows.push({ hour: hourIndex, tasks: assigned });
    rows.sort((a, b) => a.hour - b.hour);

    actions.saveProgram(program, studyId, method).then(function (payload) {
      // TODO error handling
    });

    mc.ui.modal(null);
  }

  cancel() {
    mc.ui.modal(null);
  }

  render() {
    let { activities, diaries } = this.props;
    let { assigned, unassigned, term } = this.state;

    let hash = mc.utils.hash(activities.concat(diaries), "id");

    return (
      <div className="rc-schedule-form-view">
        <h1>{this.title()}</h1>
        <div className="rc-schedule-form-view-list">
          {unassigned.length > 10 && (
            <div className="rc-schedule-form-view-search">
              <input type="search" value={term} placeholder={tx("search")} onChange={this.setTerm.bind(this)}/>
            </div>
          )}
          {mc.utils.filter(unassigned, ["displayName"], term).map((function (task) {
            return (
              <UnassignedOption
                id={task.id}
                key={task.id}
                type={task.instructions ? "activity" : "diary"}
                displayName={task.displayName}
                onAssign={this.assign.bind(this, task.id)}/>
            );
          }).bind(this))}
        </div>
        <div className="rc-schedule-form-view-list">
          <Orderable onOrder={this.reorder.bind(this)}>
            {assigned.map((function (task, i) {
              let proto = hash[task.id];

              return (
                <AssignedOption
                  id={task.id}
                  key={[i, task.id]}
                  orderId={i}
                  type={proto.instructions ? "activity" : "diary"}
                  displayName={proto.displayName}
                  onUnassign={this.unassign.bind(this, i)}/>
              );
            }).bind(this))}
          </Orderable>
        </div>
        <FormControls onSave={this.saveSchedule.bind(this)} onCancel={this.cancel.bind(this)}/>
      </div>
    );
  }
}

module.exports = ProgramView;